import React from 'react';
import { Container, Row } from 'reactstrap';
import DefaultTabsBorderedTop from './components/DefaultTabsBorderedTop';

const ClinicHistoryView = (props) => {
 return (<Container className="dashboard">
          <Row>
              <DefaultTabsBorderedTop data={props.location.state.data} />
          </Row>
        </Container>)
};

export default ClinicHistoryView;